import { render } from "./OrderBoardView.vue?vue&type=template&id=5ab08887&scoped=true"
import script from "./OrderBoardView.vue?vue&type=script&lang=js"
export * from "./OrderBoardView.vue?vue&type=script&lang=js"

import "./OrderBoardView.vue?vue&type=style&index=0&id=5ab08887&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ab08887"]])

export default __exports__